export default "__VITE_ASSET__11170456__"